<template>
  <div>
    <div class="billboard-pricelist-address" v-if="!isModalLoading">
      <div class="billboard-pricelist-address__description">
        <h1 class="subhead">Address</h1>
        <div class="subhead">{{address}}</div>
      </div>
      <div class="billboard-pricelist-address__image">
        <img :src="imageUrl ? imageUrl : placeHolder" alt="">
      </div>
      <div v-if="OperatingHours && OperatingHours.length"  class="billboard-pricelist-address__operating-hour">
        <div class="billboard-pricelist-address__operating-hour__title">
          <span class="regular-font">Operating Hours</span>
        </div>
        <div class="billboard-pricelist-address__operating-hour__content">
          <div class="billboard-pricelist-address__operating-hour__content--item" v-for="(operatinghour, index) in OperatingHours" :key="index">
            <span class="days">{{operatinghour.day}}</span>
            <span :class="['times', operatinghour.isOpen ? '' : 'day-close', 'subhead']">
              {{operatinghour.time}}
            </span>
          </div>
        </div>
      </div>
    </div>
    <a-loading v-else/>
  </div>
</template>

<script>
import api from '@/api'
import { restEdge } from "@/api/edgeUrls"

import { ALoadingPrimary } from "ui-kit-v1"

export default {
  name: 'adx-billboard-placement-address',
  components: {
    'a-loading': ALoadingPrimary,
  },
  props: {
    placementId: {
      type: Number,
      required: false
    }
  },
  data() {
    return {
      isModalLoading: false,
      bottomPrice: null,
      quantity: null,
      minQuantity: null,
      address: null,
      minPeriod: null,
      minPeriodPlan: null,
      imageUrl: null,
      placeHolder: "/img/notfound/img-placeholder_square.jpg",
      days: {
        0: 'Sunday',
        1: 'Monday',
        2: 'Tuesday',
        3: 'Wednesday',
        4: 'Thursday',
        5: 'Friday',
        6: 'Saturday',
      },
      OperatingHours: [
        {
          day : 'Sunday',
          isOpen: false,
          time: 'Unavailable'
        },
        {
          day : 'Monday',
          isOpen: false,
          time: 'Unavailable'
        },
        {
          day : 'Tuesday',
          isOpen: false,
          time: 'Unavailable'
        },
        {
          day : 'Wednesday',
          isOpen: false,
          time: 'Unavailable'
        },
        {
          day : 'Thursday',
          isOpen: false,
          time: 'Unavailable'
        },
        {
          day : 'Friday',
          isOpen: false,
          time: 'Unavailable'
        },
        {
          day : 'Saturday',
          isOpen: false,
          time: 'Unavailable'
        },
      ],
    }
  },
  computed: {

  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {
    this.loadData()
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    async loadData() {
      this.isModalLoading = true
      const { data, status } = await api.get(restEdge.billboardPricelistDetail(this.placementId), { needToken: true, useRestEdge: true })

      if (status === 200) {
        this.address = data.location.location_detail.address
        if (data.location.operating_hours) {
          for (let day of data.location.operating_hours) {
            this.OperatingHours[day.day_of_week].isOpen = true
            this.OperatingHours[day.day_of_week].time = this.timeDisplay(day)
          }
        }

        if (data.location.location_map) {
          this.imageUrl = data.location.location_map
        }
      }

      this.isModalLoading = false
    },
    pluralize(value, label) {
      if (value > 1) {
        return `${value} ${label}s`
      }
      return `${value} ${label}`
    },
    timeFormatter(value) {
      let valueString = value.toString()
      if (valueString.length < 2) return '0' + valueString
      return value
    },
    timeDisplay(time) {
      return `${this.timeFormatter(time.start)} - ${this.timeFormatter(time.end)} WIB`
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>
